import { useMemo } from 'react';
import { connect } from 'react-redux';
import { Button, Box } from '@mui/material';
import { useMaterialReactTable, MaterialReactTable } from 'material-react-table';
import { arraysEqual } from '../../../../utils/collections';
import { tableSelectionOptions, defaultTableOptions } from '../../../util/data-table';
import { locationNameId, locationTypeId, locationColumns } from '../../columns';
import { createLink, deleteLink } from '../../../../redux/actions/buildings';

const FeedsLocation = ({
  equipment,
  locationsByName,
  canWrite,

  feedsCreate,
  feedsDelete,
}) => {
  const columns = useMemo(() => locationColumns(), []);
  const data = useMemo(
    // Default order selected first
    () =>
      Object.values(locationsByName).sort((a, b) => {
        if (a.fedByEquipment.includes(equipment.published?.id)) {
          if (b.fedByEquipment.includes(equipment.published?.id)) {
            return a.name.localeCompare(b.name);
          }
          return -1;
        }
        if (b.fedByEquipment.includes(equipment.published?.id)) return 1;
        return a.name.localeCompare(b.name);
      }),
    [locationsByName, equipment]
  );

  const mrt = useMaterialReactTable({
    ...defaultTableOptions,
    ...tableSelectionOptions,
    columns,
    data,
    initialState: {
      showColumnFilters: true,
      columnVisibility: Object.fromEntries(
        columns
          .map((c) => c.id)
          .filter((id) => ![locationNameId, locationTypeId].includes(id))
          .map((id) => [id, false])
      ),
      rowSelection: Object.fromEntries(
        equipment.published.locationRelationships?.targets?.map((l) => [l.location_name, true])
      ),
    },
    getRowId: (l) => l.name,
    enableRowSelection: () => canWrite,
    renderTopToolbarCustomActions: ({ table }) => {
      const handleApply = () => {
        const selectedNames = table
          .getSelectedRowModel()
          .flatRows.map(({ original }) => original.name);
        function handleRemove() {
          const locationsToRemove = equipment.published.locationRelationships?.targets
            ?.map((l) => l.location_name)
            .filter((l) => !selectedNames.includes(l));
          if (locationsToRemove.length > 0) return feedsDelete(locationsToRemove);
          return Promise.resolve();
        }
        function handleAdd() {
          const locationsToAdd = selectedNames.filter(
            (l) =>
              !equipment.published.locationRelationships?.targets
                ?.map((lo) => lo.location_name)
                ?.includes(l.name)
          );
          if (locationsToAdd.length > 0) return feedsCreate(locationsToAdd);
          return Promise.resolve();
        }
        return handleRemove().then(() => handleAdd());
      };

      return (
        <Box sx={{ display: 'flex', gap: '0.5rem' }}>
          <Button
            color="success"
            disabled={
              !canWrite ||
              arraysEqual(
                table
                  .getSelectedRowModel()
                  .flatRows.map(({ original }) => original.name)
                  .toSorted(),
                equipment.published.locationRelationships?.targets?.map((l) => l.location_name)
              )
            }
            onClick={handleApply}
            variant="contained"
          >
            Apply Selection
          </Button>
        </Box>
      );
    },
  });
  return <MaterialReactTable table={mrt} />;
};

function mapStateToProps(state, { building }) {
  return {
    locationsByName: state.entities.buildings.locationsByBuildingIdName[building.id] ?? {},
    canWrite: building.canWrite,
  };
}

function mapDispatchToProps(dispatch, { equipment, building }) {
  return {
    feedsCreate: (newFeedsLocations) =>
      dispatch(
        createLink(building.id, 'FEEDS', equipment.publishedEquipmentId, newFeedsLocations, [])
      ),
    feedsDelete: (feedsLocationsToRemove) =>
      dispatch(
        deleteLink(building.id, 'FEEDS', equipment.publishedEquipmentId, feedsLocationsToRemove, [])
      ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(FeedsLocation);
